import { Injectable } from "@angular/core";
import { convertBlobToBase64 } from "@cotecna/camera";
import { ImageService } from "@cotecna/image";
import { HttpService } from "src/app/session/services/http.service";
import { convertBase64ToBlob } from "src/app/shared/utils/blob-utils";
import { environment } from "src/environments/environment";
import { DEFAULT_MIME_TYPE } from "../../constants/constants";

@Injectable({
  providedIn: "root",
})
export class InspectionPhotoService {
  constructor(
    private httpService: HttpService,
    private imageService: ImageService,
  ) {}

  public async uploadPhotos(
    inspectionId: string,
    files: File[],
  ): Promise<void> {
    const formData = await this.createFormData(inspectionId, files);
    await this.httpService
      .post(
        `${environment.webApiUrl}/api/pictures/uploadMultiple/${inspectionId}`,
        formData,
        { withCredentials: true },
      )
      .toPromise();
  }

  private async createFormData(
    inspectionId: string,
    files: File[],
  ): Promise<FormData> {
    const formData = new FormData();
    for (const index in files) {
      const file = files[index];
      const fileName = this.generatePhotoFileName(inspectionId);

      const fullPhotoRaw = await convertBlobToBase64(file);
      const thumbnailRaw =
        await this.imageService.thumbnailFromBase64(fullPhotoRaw);

      const fullPhoto =
        this.imageService.removeDataPrefixFromBase64(fullPhotoRaw);
      const thumbnail =
        this.imageService.removeDataPrefixFromBase64(thumbnailRaw);

      const blobOriginal = convertBase64ToBlob(fullPhoto, file.type);
      const blobThumbnail = convertBase64ToBlob(thumbnail, DEFAULT_MIME_TYPE);

      formData.append(`fileOriginal_${index}`, blobOriginal, fileName);
      formData.append(`fileThumbnail_${index}`, blobThumbnail, fileName);
    }
    return formData;
  }

  private generatePhotoFileName(inspectionId: string): string {
    let date = new Date();
    let time = date.getTime();
    return `${inspectionId}--${time}`;
  }
}
